import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { MODULE_ORDER, MODULE_SCHEMAS } from "../lib/moduleSchemas";
import EntityFormDialog from "./EntityFormDialog";
import { api } from "../lib/api";
import { toast } from "sonner";
import {
  Users, Phone, Landmark, TrendingUp, Shield, CreditCard, Home, Lock,
  TrendingDown, FileText, Receipt, Briefcase, IndianRupee, RefreshCw,
  KeyRound, ClipboardCheck, Plus,
} from "lucide-react";

const ICON_MAP = {
  Users, Phone, Landmark, TrendingUp, Shield, CreditCard, Home, Lock,
  TrendingDown, FileText, Receipt, Briefcase, IndianRupee, RefreshCw,
  KeyRound, ClipboardCheck,
};

export default function QuickAdd({ onCreated }) {
  const [picker, setPicker] = useState(false);
  const [formFor, setFormFor] = useState(null); // module slug
  const navigate = useNavigate();

  const pick = (slug) => {
    setPicker(false);
    setFormFor(slug);
  };

  const submit = async (payload) => {
    try {
      await api.post(`/entities/${formFor}`, { module: formFor, ...payload });
      toast.success(`Added to ${MODULE_SCHEMAS[formFor].label}`);
      onCreated?.();
    } catch {
      toast.error("Save failed");
      throw new Error("save");
    }
  };

  return (
    <>
      <Button
        size="sm"
        onClick={() => setPicker(true)}
        className="h-8 gap-1.5"
        data-testid="quick-add-button"
      >
        <Plus className="h-4 w-4" /> <span className="hidden sm:inline">Quick add</span>
      </Button>

      <Dialog open={picker} onOpenChange={setPicker}>
        <DialogContent className="sm:max-w-xl">
          <DialogHeader>
            <DialogTitle>What would you like to add?</DialogTitle>
          </DialogHeader>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2">
            {MODULE_ORDER.map((slug) => {
              const s = MODULE_SCHEMAS[slug];
              const Icon = ICON_MAP[s.icon] || FileText;
              return (
                <button
                  key={slug}
                  onClick={() => pick(slug)}
                  className="group flex items-center gap-2 p-3 rounded-md border border-slate-200 hover:border-slate-900 hover:bg-slate-50 transition-all text-left"
                  data-testid={`quick-add-module-${slug}`}
                >
                  <div className="h-8 w-8 rounded bg-slate-100 group-hover:bg-slate-900 group-hover:text-white flex items-center justify-center shrink-0 transition-colors">
                    <Icon className="h-4 w-4" strokeWidth={1.75} />
                  </div>
                  <span className="text-sm font-medium truncate">{s.label}</span>
                </button>
              );
            })}
          </div>
        </DialogContent>
      </Dialog>

      {formFor && (
        <EntityFormDialog
          open={!!formFor}
          onOpenChange={(o) => !o && setFormFor(null)}
          schema={MODULE_SCHEMAS[formFor]}
          initial={null}
          onSubmit={async (p) => { await submit(p); navigate(`/m/${formFor}`); }}
          title={`Add ${MODULE_SCHEMAS[formFor].label}`}
        />
      )}
    </>
  );
}
